<template>
  <label v-if="label" :for="props.for" :class="classes">
    {{ label }}
    <span v-if="labelHint" class="font-normal text-slate-400 pr-0.5">{{
        labelHint
      }}</span>
    <span v-if="required" class="text-red-600">*</span>
  </label>
</template>

<script setup>
import {twMerge} from "tailwind-merge";

const props = defineProps({
  label: String,
  labelHint: String,
  required: Boolean,
  for: String,
  class: String,
});

const classes = twMerge(
  "block mb-1.5 text-sm font-bold text-gray-700 capitalize break-words",
  props.class
);
</script>
